import { Link } from '@tanstack/react-router';
import { Button } from '@ludolio/shared-ui';
import { TeamRoleBadge } from '@/components/common';
import { useLabs } from '@/lib/labs-context';
import type { LabProjectDetail } from '@/lib/types';

export function MembersPanel({ detail }: { detail: LabProjectDetail }) {
  const labs = useLabs();

  return (
    <section className="space-y-4">
      <div className="flex min-h-9 flex-wrap items-center justify-between gap-4">
        <h2 className="truncate text-base font-semibold">{detail.project.team.name}</h2>
        <Button variant="outline" asChild>
          <Link
            to="/$orgSlug/teams/$teamId"
            params={{ orgSlug: labs.organization.slug, teamId: detail.project.team.id }}
          >
            Open team
          </Link>
        </Button>
      </div>
      <ul className="divide-y rounded-lg border">
        {detail.members.map((member) => (
          <li key={member.userId} className="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-4 p-4">
            <div className="min-w-0">
              <p className="truncate font-medium">
                {member.name}{member.userId === labs.user.id ? ' (you)' : ''}
              </p>
              <p className="truncate text-sm text-muted-foreground">{member.email}</p>
            </div>
            <TeamRoleBadge role={member.role} />
          </li>
        ))}
      </ul>
    </section>
  );
}
